import styles from "./About.styles";
import Hero from "./sections/Hero";
import Values from "./sections/Values";
import Seo from "../../components/Seo";
import { useI18n } from "../../i18n";

export default function About() {
  const { t } = useI18n();
  return (
    <div className={`${styles.container}`}>
      <Seo title={t("seo_about_title")} description={t("seo_about_desc")} />
      <Hero/>
      <Values/>
    </div>
  );
}
